/**
 * Settings → This computer, in the desktop app only: a way into the app's own
 * settings (docs/desktop-bridge.md, `openSettings`). Folders, servers,
 * computer use and Dispatch are the app's, not the page's, so a page can open
 * them but never change them.
 */

import { openDesktopSettings } from '../../desktop';
import { ds } from '../../ds';
import { useApp } from '../../state';
import { Ph } from '../ui';

const SECTIONS: { section: 'folders' | 'servers' | 'computer'; icon: string; title: string; detail: string }[] = [
  { section: 'folders', icon: 'folder', title: 'Folders', detail: 'Assist reads files in these without asking.' },
  { section: 'servers', icon: 'plugs-connected', title: 'Servers', detail: 'Programs on this computer whose tools Assist may use.' },
  { section: 'computer', icon: 'desktop', title: 'Computer', detail: 'Computer use, Dispatch and paired phones.' }
];

export function ComputerTab() {
  const { Button } = ds();
  const { pcRefused } = useApp();
  return (
    <div style={{ display: 'flex', flexDirection: 'column', gap: 12 }}>
      <p style={{ margin: 0, fontSize: 13.5, color: 'var(--text-muted)' }}>
        These are kept by the app, so no web page can change them.
      </p>
      {pcRefused ? (
        <p role="status" style={{ margin: 0, display: 'flex', gap: 8, alignItems: 'flex-start', fontSize: 13.5, color: 'var(--danger-600)' }}>
          <Ph name="warning-circle" size={16} style={{ flexShrink: 0, marginTop: 1 }} />
          <span>Dispatch could not add this PC. {pcRefused}</span>
        </p>
      ) : null}
      <div style={{ background: 'var(--surface-card)', borderRadius: 'var(--radius-app-card)', overflow: 'hidden' }}>
        {SECTIONS.map((s, i) => (
          <div
            key={s.section}
            style={{
              display: 'flex',
              alignItems: 'center',
              gap: 12,
              padding: '12px 16px',
              ...(i ? { borderTop: '1px solid var(--border-subtle)' } : {})
            }}
          >
            <Ph name={s.icon} size={16} style={{ color: 'var(--text-muted)' }} />
            <div style={{ flex: 1, minWidth: 0, display: 'flex', flexDirection: 'column', gap: 2 }}>
              <span style={{ fontSize: 14, fontWeight: 600, color: 'var(--text-strong)' }}>{s.title}</span>
              <span style={{ fontSize: 12.5, color: 'var(--text-muted)' }}>{s.detail}</span>
            </div>
            <Button variant="neutral" density="app" size="sm" onClick={() => void openDesktopSettings(s.section)}>
              Open
            </Button>
          </div>
        ))}
      </div>
    </div>
  );
}
